// TODO: namespacing update
Postlogin.OverviewReport = (function () {
    const me = {};

    me.init = function () {
        me.initEvents();
        me.updateOverviewTotals();
    };

    me.initEvents = function () {
        // Ported from bootstrap-select to Tom Select 2026-05-12.
        // changed.bs.select was bootstrap-select's custom event;
        // Tom Select propagates the native <select>'s `change` event
        // on every pick/remove, which is exactly what we want here.
        const overviewLicenses = $('#overview_license_ids');
        const overviewLicensesEl = overviewLicenses[0];
        if (overviewLicensesEl) {
            // eslint-disable-next-line no-new
            new TomSelect(overviewLicensesEl, {
                placeholder: 'All licenses selected',
                plugins: ['remove_button'],
                diacritics: true,
                maxOptions: null,
            });
        }

        overviewLicenses.on('change', (e) => {
            me.updateOverview(e);
        });

        const lessonCompletionGrades = $('#lesson-completion-grades');
        const lessonCompletionGradesEl = lessonCompletionGrades[0];
        if (lessonCompletionGradesEl) {
            // eslint-disable-next-line no-new
            new TomSelect(lessonCompletionGradesEl, {
                placeholder: 'All Grades',
                plugins: ['remove_button'],
                diacritics: true,
                maxOptions: null,
            });
        }

        lessonCompletionGrades.on('change', () => {
            me.updateLessonCompletion();
        });

        $('#lesson-completion-export-button').on('click', () => {
            me.exportLessonCompletion();
        });

        const chartsButtons = $('#charts-container').find('.chart-btn');
        chartsButtons.on('click', (e) => {
            e.preventDefault();

            chartsButtons.filter('.active').removeClass('active');
            const currentChart = $(e.currentTarget);
            currentChart.addClass('active');

            if (currentChart.data('chart-type') === 'lesson_completion') {
                me.showLessonCompletion();
            } else {
                me.showLegacyCharts();
                me.updateLineCharts();
            }
        });

        const currentDate = new Date(new Date().setHours(23, 59, 59));
        const dateOptions = {
            restrictions: {
                maxDate: currentDate,
            },
            display: {
                theme: 'light',
                components: {
                    clock: false,
                },
            },
        };
        const overviewDateStart = new tempusDominus.TempusDominus(document.getElementById('overview-start-date'), {
            ...dateOptions,
            container: document.getElementById('overview-start-date-container'),
        });

        const overviewDateEnd = new tempusDominus.TempusDominus(document.getElementById('overview-end-date'), {
            ...dateOptions,
            container: document.getElementById('overview-end-date-container'),
        });

        overviewDateStart.subscribe(tempusDominus.Namespace.events.change, (e) => {
            overviewDateEnd.updateOptions({
                restrictions: {
                    minDate: e.date,
                },
            });
        });
        overviewDateEnd.subscribe(tempusDominus.Namespace.events.change, (e) => {
            overviewDateStart.updateOptions({
                restrictions: {
                    maxDate: e.date,
                },
            });
        });

        const onUpdateData = $('#update-data-button');
        onUpdateData.on('click', (e) => {
            me.updateOverview(e);
        });

        $('#overview-search-date').on('change', (e) => {
            const value = $('#overview-search-date option:selected').val();
            if (value === 'custom') {
                $('#overview-start-date').val(moment().subtract(14, 'days').format('L'));
                $('#overview-end-date').val(moment().format('L'));

                $('.charts-dates .date-container.hide').removeClass('hide');
            } else {
                $('.charts-dates .date-container').addClass('hide');
                me.updateOverview(e);
            }
        });
    };

    me.updateOverview = function () {
        $('#usage-container').find('.card').find('span').addClass('blur');
        me.updateOverviewTotals();

        if ($('#charts-container').find('.chart-btn.active').data('chart-type') === 'lesson_completion') {
            me.updateLessonCompletion();
        }
    };

    me.showLessonCompletion = function () {
        $('#legacy-usage-charts').addClass('hide');
        $('#lesson-completion-grade-container').removeClass('hide');
        $('#lesson-completion-container').removeClass('hide');
        me.updateLessonCompletion();
    };

    me.showLegacyCharts = function () {
        $('#lesson-completion-container').addClass('hide');
        $('#lesson-completion-grade-container').addClass('hide');
        $('#legacy-usage-charts').removeClass('hide');
    };

    me.updateOverviewTotals = function () {
        $.ajax({
            url: $('#usage-container').data('usage-url'),
            data: {
                license_ids: $('#overview_license_ids').val(),
                date: $('#overview-search-date option:selected').val(),
                date_range_from: $('#overview-start-date').val(),
                date_range_to: $('#overview-end-date').val(),
            },
            dataType: 'json',
            async: false,
            success(data) {
                me.chartData = data.data;
                const usageTotals = data.data.usage_totals;
                $('#user-count').text(usageTotals.user_count);
                $('#admin-count').text(usageTotals.admin_count);
                $('#last-logins').text(usageTotals.seven_day_login);
                $('#recent-videos-watched').text(usageTotals.thirty_day_videos);
                $('#usage-container').find('.card').find('span').removeClass('blur');

                google.charts.load('current', {
                    packages: ['corechart', 'bar'],
                });
                google.charts.setOnLoadCallback(me.updateAllCharts);
            },
        });
    };

    me.updateAllCharts = function () {
        me.updateLineCharts();
        me.updatePieCharts();
    };

    me.chartData = [];
    me.updateLineCharts = function () {
        const selectedChart = $('#charts-container').find('.chart-btn.active');
        const data = me.chartData.usage_dates;
        const type = selectedChart.data('chart-type');
        const d = new google.visualization.DataTable();

        d.addColumn('date', 'Date');
        d.addColumn('number', me.lineChartOptions[type].title);

        d.addColumn({ type: 'string', role: 'tooltip', p: { html: true } });

        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < data.length; i++) {
            const date = moment().set({
                year: data[i].year,
                month: data[i].month - 1,
                date: 1,
                hour: 0,
                minute: 0,
                seconds: 0,
            });

            const dataPointRaw = type === 'time_spent_time' ? me.getTimeSpentHours(data[i]) : data[i][type];
            const dataPoint = dataPointRaw ? parseFloat(dataPointRaw) : 0;
            const displayText = type === 'time_spent_time' ? me.getTimeSpentDisplay(data[i]) : dataPoint;

            const $tooltip = `<div style='padding:20px; font-size: 14px;'><b>
                ${date.format('MMMM, YYYY')}</b><br/><br/>${me.lineChartOptions[type].title}: <b>${displayText}</b></div>`;

            d.addRow([date.toDate(), dataPoint, $tooltip]);

            if (data.length === 1) {
                const extraTime = moment().set({
                    year: data[i].year,
                    month: data[i].month - 1,
                    date: 1,
                    hour: 1,
                    minute: 0,
                    seconds: 0,
                });

                d.addRow([extraTime.toDate(), dataPoint, $tooltip]);
            }
        }

        // draw chart
        const chart = new google.visualization.AreaChart($('#usage-chart').get(0));
        me.lineGraphOptions.width = $('#usage-chart').width();
        me.lineGraphOptions.hAxis.format = 'MMM y';
        chart.draw(d, me.lineGraphOptions);

        $(window).on('resize', _.debounce(me.updateLineCharts, 250));
    };

    me.getTimeSpentHours = (monthData) => {
        const rawTime = monthData.time_spent_raw / 3600;

        return parseFloat(rawTime).toFixed(2);
    };

    me.getTimeSpentDisplay = (monthData) => {
        const rawTime = monthData.time_spent_raw;
        const hours = Math.floor(rawTime / 3600);
        const minutes = Math.floor((rawTime % 3600) / 60);

        return `${hours} hours, ${minutes} minutes`;
    };

    me.lineChartOptions = {
        time_spent_time: {
            title: 'Time Spent',
        },
        site_visits: {
            title: 'Site Visits',
        },
        careers_viewed: {
            title: 'Careers Viewed',
        },
        videos_watched: {
            title: 'Videos Watched',
        },
    };

    me.lineGraphOptions = {
        height: 400,
        width: $('#usage-chart').width(),
        legend: 'none',
        lineWidth: 3,
        pointSize: 5.5,
        tooltip: { isHtml: true },
        chartArea: { width: '90%', height: '65%' },
        animation: {
            startup: true,
            duration: 400,
        },
        bar: {
            groupWidth: '95%',
        },
        hAxis: {
            format: 'MMM y',
            gridlineColor: '#fff',
        },
        vAxis: {
            format: '#,###',
            viewWindow: {
                min: 0,
            },
        },
        colors: ['#3B83BD'],
        areaOpacity: 0.7,
    };

    me.updatePieCharts = function () {
        const clusterData = me.chartData.top_clusters;
        const careerData = me.chartData.top_careers;
        const clusterContainer = $('#clusters-pie-chart');
        const careerContainer = $('#careers-pie-chart');

        me.buildPieChart(clusterData, clusterContainer);
        me.buildPieChart(careerData, careerContainer);

        $(window).on('resize', _.debounce(me.updatePieCharts, 250));
    };

    me.buildPieChart = function (data, $chartContainer) {
        const d = new google.visualization.DataTable();

        d.addColumn('string', 'Title');
        d.addColumn('number', 'Visits');
        d.addColumn({ type: 'string', role: 'tooltip', p: { html: true } });

        const chartData = _.map(data, (item) => [
            item.title,
            item.total,
            `<div style="padding:20px; font-size: 14px;">${item.title}<br/><br/><b>${item.total} Visits</b></div>`,
        ]);
        d.addRows(chartData);

        me.pieChartOptions.width = $('#usage-chart').width() / 2.5;
        const chart = new google.visualization.PieChart($chartContainer.get(0));
        chart.draw(d, me.pieChartOptions);
    };

    me.pieChartOptions = {
        animation: {
            duration: 2000,
        },
        // is3D: true,
        height: 400,
        lineWidth: 3,
        pointSize: 5.5,
        tooltip: { isHtml: true },
        chartArea: { width: '100%', height: '85%' },
        sliceVisibilityThreshold: 0.01,
        colors: ['#3F6386', '#316C9B', '#3678AC', '#3B83BD', '#629BD1', '#70A4D5', '#82B0D5', '#8CB6DD', '#7EADD9', '#C0DDF7'],
    };

    me.lessonCompletionParams = function () {
        return {
            license_ids: $('#overview_license_ids').val(),
            grade_bands: $('#lesson-completion-grades').val(),
            date: $('#overview-search-date option:selected').val(),
            date_range_from: $('#overview-start-date').val(),
            date_range_to: $('#overview-end-date').val(),
        };
    };

    me.lessonCompletionData = null;
    me.updateLessonCompletion = function () {
        $.ajax({
            url: $('#lesson-completion-container').data('lesson-completion-url'),
            data: me.lessonCompletionParams(),
            dataType: 'json',
            success(data) {
                me.lessonCompletionData = data.data;
                me.renderLessonCompletionBarChart();
                me.renderLessonCompletionTable();
                me.renderLessonCompletionVideoViews();
            },
        });
    };

    me.renderLessonCompletionBarChart = function () {
        const d = new google.visualization.DataTable();
        d.addColumn('string', 'Lessons Completed');
        d.addColumn('number', 'Student-Led');
        d.addColumn({ type: 'string', role: 'tooltip' });
        d.addColumn('number', 'Teacher-Led');
        d.addColumn({ type: 'string', role: 'tooltip' });

        // Each row is a lessons-completed bucket (L1-L5+), not a lesson --
        // the two stacked series are independent per-student tallies: how
        // many students had that many student-led completions, and how
        // many had that many teacher-led completions.
        d.addRows(_.map(me.lessonCompletionData.lesson_data, (bucket) => [
            bucket.lessons_completed,
            bucket.student_led,
            `${bucket.student_led} student(s) completed ${bucket.lessons_completed} student-led lesson(s)`,
            bucket.teacher_led,
            `${bucket.teacher_led} student(s) completed ${bucket.lessons_completed} teacher-led lesson(s)`,
        ]));

        const chart = new google.visualization.ColumnChart($('#lesson-completion-bar-chart').get(0));
        chart.draw(d, {
            isStacked: true,
            height: 360,
            width: $('#lesson-completion-bar-chart').width(),
            chartArea: { width: '85%', height: '55%' },
            legend: { position: 'top', textStyle: { fontSize: 11 } },
            colors: ['#3B83BD', '#3F6386'],
            // viewWindowMode must be 'explicit' for viewWindow.min to be
            // enforced -- otherwise Charts defaults to 'pretty' mode and
            // can still round the axis padding below zero.
            vAxis: { title: 'Students', viewWindowMode: 'explicit', viewWindow: { min: 0 } },
            hAxis: { title: 'Lessons Completed' },
        });

        $(window).on('resize', _.debounce(me.renderLessonCompletionBarChart, 250));
    };

    me.renderLessonCompletionTable = function () {
        const $table = $('#lesson-completion-table');
        if ($table.data('bootstrap.table')) {
            $table.bootstrapTable('destroy');
        }

        $table.bootstrapTable({
            classes: 'table table-hover table-condensed',
            data: me.lessonCompletionData.school_breakdown,
            pagination: me.lessonCompletionData.school_breakdown.length > 25,
            pageSize: 25,
            search: false,
            showColumns: false,
            sidePagination: 'client',
            striped: true,
            formatNoMatches() {
                return 'No lesson completions to show';
            },
        });
    };

    me.renderLessonCompletionVideoViews = function () {
        $('#lesson-completion-student-videos').text(me.lessonCompletionData.video_views.students);
        $('#lesson-completion-teacher-videos').text(me.lessonCompletionData.video_views.teachers);
    };

    me.exportLessonCompletion = function () {
        const params = _.extend({}, me.lessonCompletionParams(), {
            columns: [
                ['School', 'school'],
                ['Grade Band', 'grade_band'],
                ['Student-Initiated Lessons Completed', 'student_initiated'],
                ['Teacher-Led Lessons Completed', 'teacher_led'],
                ['Students Who Experienced Teacher-Led Lessons', 'students_teacher_led'],
                ['Total Lessons Completed', 'total'],
            ],
        });

        const queryString = $.param(params);
        window.open(`${$('#lesson-completion-container').data('lesson-completion-export-url')}?${queryString}`, '_blank');
    };

    return {
        init: me.init,
        update: me.updateOverview,
    };
}());
